import React from 'react';
import { Image } from 'react-bootstrap';
import lekeTedavisi from '../../images/home/taniTedavi/16001738625587.jpg';
import '../../styles/about.css';

const TaniTedavi14 = () => {
    return (
        <div>
            <h5 className='main-title'>MEZOTERAPİ NEDİR, NERELERDE KULLANILIR?</h5>
            <hr />
            <p>Mezoterapi, Yunanca "orta" anlamına gelen "mesos" ve medikal olarak "tedavi etmek" anlamına gelen "therapeia" kelimelerinden oluşur. Mezoterapi, farmakolojik ilaçların deri içine ve altına enjekte edilmesi tekniğidir. Deri ve deri altının fiziksel ve kimyasal olarak uyarılması sağlanır. Bu yöntem, gerekli dokuya enjeksiyon ile daha az dozda ilaç kullanımına izin verir. Ayrıca ilaçların sistemik uygulamadaki etkilerini de azaltmış olur. Mezoterapi, dermatokozmatolojide yüz gençleştirme, saç dökülmesi, selülit ve lokal yağ depolanmasının tedavisinde kullanılır.</p>

            <p>Yüz mezoterapisinde amaç, derinin yenilenmesi, nemlendirilmesi, yaşlanmanın önlenmesi, kırışıklıkların ve sarkmaların giderilmesidir. Birtakım vitaminler, yaşlanma karşıtı maddeler, mineraller, proteinler ve hyaluronik asit, mikro iğnecikler aracılığı ile cilt altına uygulanır. Bu sayede deride fibroblast denen yenileyici hücreler artar. Yeni kollajen, elastin ve hyaluronik asit üretimi artar. Sonuç olarak, derinin nemi, parlaklığı ve sıkılığı artırılır.</p>

            <p>Uygulama, 1-2 hafta aralıklarla ortalama 6-8 seans uygulanır. Bu yöntem, boyun ve dekolte bölgesinin düzeltilmesinde de yaygın olarak kullanılır.</p>

            <Image src={lekeTedavisi} fluid className='mb-4' style={{ width: '70%' }} />

            <p>Saçlı deri mezoterapisi, saç dökülmesini durdurmak, var olan saçın kalitesini artırmak ve yeni saç çıkışını aktif hale getirmek için belirli periyotlarla uygulanır. Saçın ihtiyacı olan vitaminler, mineraller, proteinler ve karışımlar mikro iğnecikler yardımıyla saçlı deriye uygulanır.</p>

            <p>Değişik tedavi protokolleri olmakla birlikte, 1-2 hafta aralıklarla 10-12 seans uygulanır.</p>

            <p>Selülit ve yağ eritme mezoterapisinde, birtakım ilaçlarla lipo ödemin azaltılması, kan dolaşımının arttırılması, yağın eritilmesi ve destek dokuların onarılması amaçlanır. Bu amaçla lipolitik (yağ eritici), dolaşım düzenleyici ve bağ dokusuna etkili güçlendirici ilaçlar enjekte edilir.</p>

            <p>Kol, bacaklar, karın, kalçalar ve basen bölgeleri, uygulama alanlarıdır.</p>
        </div>
    );
};

export default TaniTedavi14;
